module.exports = __webpack_public_path__ + "static/media/trimex_tacurina.bac765dc.png";